<template>
  <div class="surveys-tour">
    <div class="tour-overlay" v-if="showTour"></div>
    <v-tour
      name="myTour"
      :steps="tourSteps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { setDocumentBodyOverflowProperty } from "@/common/util";
export default {
  name: "TheSurveysTour",
  props: {},
  data() {
    return {
      tourSteps: [
        {
          target: "#v-step-0",
          header: {
            title: "Save Button",
          },
          content: `Click this button to save your current progress.`,
        },
        {
          target: "#v-step-1",
          header: {
            title: "Survey Score",
          },
          content: `This indicates your current score though it may not reflect your actual score.This can be changed at the end of survey.`,
        },
      ],
      tourCallbacks: {
        onFinish: this.$_tourCallbacks,
        onSkip: this.$_tourCallbacks,
      },
    };
  },
  mounted() {
    if (this.showTour) {
      setDocumentBodyOverflowProperty("hidden");
      this.$tours["myTour"].start();
    }
  },
  computed: {
    ...mapState({
      showTour: (state) => state.Surveys.showSurveyTour,
    }),
  },
  methods: {
    $_tourCallbacks() {
      this.$emit("tourCallback");
    },
  },
};
</script>
<style lang="scss" scoped>
.surveys-tour {
  .tour-overlay {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 9999;
  }
}
</style>
